import { usePermissions } from "contexts/app/permissions";
import { Permission } from "api/zekay/permissions";
import useAppSettings from "contexts/app/appSettings";

export function useExcursionPlanningPermissions() {
  const { hasPermission } = usePermissions();
  const { config } = useAppSettings();
  const customersSyncActive = config?.CustomersSync === true;
  const hasExcursionsEdit = hasPermission(Permission.EXCURSIONS_EDIT);
  const hasExcursionsView = hasPermission(Permission.EXCURSIONS_VIEW);
  const canEdit = hasExcursionsEdit && !customersSyncActive;
  const canSendSMS = hasPermission(Permission.EXCURSIONS_SEND_SMS);
  /** When `CustomersSync` is true, `canEdit` is false but the sortie drawer may still open (view-only, no DnD). */
  const canOpenExcursionDrawer = hasExcursionsView || hasExcursionsEdit;
  const canListBookingsForPlanning =
    hasPermission(Permission.PLANNING_BOOKING_ALL_VIEW) ||
    hasPermission(Permission.PLANNING_BOOKING_COMPANY_VIEW) ||
    hasPermission(Permission.PLANNING_BOOKING_ME_VIEW) ||
    hasPermission(Permission.EXCURSIONS_EDIT) ||
    hasPermission(Permission.EXCURSIONS_VIEW);
  const canSyncBookingsOnSave = hasExcursionsEdit && !customersSyncActive;

  return {
    canEdit,
    canSendSMS,
    canOpenExcursionDrawer,
    canListBookingsForPlanning,
    canSyncBookingsOnSave,
  };
}
